export const getCookie = ({name}: {name: string}) => {
    const uniqueName = name + '=';
    const split = document.cookie.split(';');
    for (let i = 0; i < split.length; i++) {
        let c = split[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1, c.length);
        }
        if (c.indexOf(uniqueName) === 0) {
            return c.substring(uniqueName.length, c.length);
        }
    }
    return null;
};

// ** A name can appear more than once, e.g. a parent domain's cookie is visible on app.dev.focus101.com too
export const hasCookieWithValue = ({name, value}: {name: string; value: string}) =>
    document.cookie
        .split(';')
        .some(cookie => cookie.trim() === `${name}=${value}`);

// ** app.focus101.com -> .focus101.com, app.dev.focus101.com -> .dev.focus101.com, localhost -> undefined (host-only cookie)
const getEnvCookieDomain = (): string | undefined => {
    const hostParts = window.location.hostname.split('.');
    return hostParts.length < 3 ? undefined : `.${hostParts.slice(1).join('.')}`;
};

export const setCookie = ({
    name,
    value,
    days,
    minutes,
}: {
    name: string;
    value: string;
    days: number | null;
    minutes: number | null;
}) => {
    let expires: string = '';
    let date: Date = new Date();

    if (days) {
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    }
    if (minutes) {
        date.setTime(date.getTime() + minutes * 60000);
    }

    expires = '; expires=' + date.toUTCString();

    const domain = getEnvCookieDomain();

    document.cookie =
        name +
        '=' +
        (value || '') +
        expires +
        (domain ? `;domain=${domain}` : '') +
        '; path=/';
};

export const eraseCookie = (name: string) => {
    document.cookie =
        name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';

    // ** Deleting a domain-scoped cookie requires the Domain attribute to match exactly,
    // ** so also clear the env-scoped variant in case it was set with one.
    const domain = getEnvCookieDomain();
    if (domain) {
        document.cookie =
            name +
            '=; Path=/; Domain=' +
            domain +
            '; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    }
};
